import { normalizeString } from "./normalize.js";

/** Patterns stripped when resolving versioned runtime model ids to catalog entries. */
export const VERSION_STRIP_PATTERNS: ReadonlyArray<{ re: RegExp; label: string }> = [
  { re: /-\d{4}-\d{2}-\d{2}$/, label: "date YYYY-MM-DD" },
  { re: /-\d{8}$/, label: "date YYYYMMDD" },
  { re: /-v\d+$/, label: "version -vN" },
  { re: /-\d+\.\d+\.\d+$/, label: "semver" },
  { re: /:\d+[a-z]?$/i, label: "colon version" },
  { re: /-\d{4,}$/, label: "build number" },
  { re: /@\d+$/, label: "epoch @NNNN" },
];

/** Strip version/date suffix from a bare slug (no `provider/` prefix). */
export function stripModelSlugSuffix(slug: string): string | null {
  for (const { re } of VERSION_STRIP_PATTERNS) {
    if (re.test(slug)) {
      return slug.replace(re, "");
    }
  }
  return null;
}

/**
 * Strip a version/date suffix from a model id (`gpt-5.5-2026-04-23` → `gpt-5.5`,
 * `deepseek/deepseek-v3.2-2025-06-01` → `deepseek/deepseek-v3.2`). Returns null when nothing was stripped.
 */
export function stripModelVersionSuffix(model: string): string | null {
  const normalized = normalizeString(model);
  if (!normalized) return null;

  if (normalized.includes("/")) {
    const slash = normalized.indexOf("/");
    const prefix = normalized.slice(0, slash);
    const slug = normalized.slice(slash + 1);
    const stripped = stripModelSlugSuffix(slug);
    if (stripped && stripped !== slug) {
      return `${prefix}/${stripped}`;
    }
    return null;
  }

  const stripped = stripModelSlugSuffix(normalized);
  return stripped && stripped !== normalized ? stripped : null;
}
